import { Channels } from '../../constants';
import { ConversationStatus } from '../../../api';

export const ChannelNames = [
  { value: Channels.DIRECTLINE, label: 'Веб-чат' },
  { value: Channels.TELEGRAM, label: 'Telegram' },
  { value: Channels.VIBER, label: 'Viber' },
  { value: Channels.ELMA365, label: 'ELMA365' },
  { value: Channels.EMULATOR, label: 'Эмулятор' },
];

export const Elma365ChannelIdentifiers = {
  telegram: 'Telegram',
  telegram_bot: 'Telegram Bot',
  viberbot: 'Viber',
  instagram: 'Instagram',
  vkontakte: 'VK',
  whatsapp: 'WhatsApp',
  quick: 'Линия',
} as { [x: string]: string };

export const ConversationStatusNames = [
  { value: ConversationStatus.Active, label: 'Активная' },
  { value: ConversationStatus.Closed, label: 'Закрытая' },
  { value: ConversationStatus.Operator, label: 'Переведена на оператора' },
];

export const TriggerNames = {
  Start: 'start-trigger',
  Terminal: 'terminal-trigger',
  Intent: 'intent-trigger',
  SigmaIntent: 'knowledge-base-answer-trigger',
  UnknownIntent: 'unknown-intent-trigger',
  Transition: 'transition-trigger',
  MenuButton: 'menu-button-trigger',
  ExternalEvent: 'external-event-trigger',
};

export const ActivityEventNames = {
  ScenarioStarted: 'scenario-started',
  MenuItemSelected: 'menu-item-selected',
  OmegaRecognizer: 'OmegaRecognizer',
  SigmaRecognizer: 'SigmaClient',
  PromptAccepted: 'promptAccepted',
  TransferToOperatorInitiated: 'TransferToOperatorInitiated',
  ErrorOccured: 'error',
  TriggerFired: 'trigger-fired',
  ScriptExecuted: 'ScriptExecutorService_RunScript',
};

export const TriggerDescriptions = {
  [TriggerNames.Start]: 'Старт бота',
  [TriggerNames.Terminal]: 'Триггер завершения',
  [TriggerNames.Intent]: 'Интент',
  [TriggerNames.SigmaIntent]: 'База знаний',
  [TriggerNames.UnknownIntent]: 'Неизвестный интент',
  [TriggerNames.Transition]: 'Переход из другого сценария',
  [TriggerNames.MenuButton]: 'Кнопка меню',
  [TriggerNames.ExternalEvent]: 'Внешнее событие',
};
